<div class="change-password-page">
    <div class="conatiner-page-header">Change Password</div>
    <mat-card>
        <div class="change-password-form">
            <form
                (ngSubmit)="f.form.valid && processForm()"
                #f="ngForm"
                novalidate
            >
                <!-- OLD PASSWORD -->
                <div class="form-group">
                    <mat-form-field>
                        <input
                            passwordValidator
                            type="password"
                            matInput
                            placeholder="Old Password"
                            minlength="8"
                            maxlength="32"
                            [(ngModel)]="oldPassword"
                            name="oldpwd"
                            #oldpwd="ngModel"
                            required
                        >
                    </mat-form-field>
                </div>
                <!-- NEW PASSWORD -->
                <div class="form-group">
                    <mat-form-field>
                        <input
                            passwordValidator
                            type="password"
                            matInput
                            placeholder="New Password"
                            minlength="8"
                            maxlength="32"
                            [(ngModel)]="newPassword"
                            name="newpwd"
                            #newpwd="ngModel"
                            required
                        >
                        <mat-error *ngIf="newpwd.value?.length > 0 && newpwd.touched && newpwd.hasError('passwordValidator')">Please enter valid password</mat-error>
                    </mat-form-field>
                </div>
                <!-- CONFIRM NEW PASSWORD -->
                <div class="form-group">
                    <mat-form-field>
                        <input
                            passwordValidator
                            type="password"
                            matInput
                            placeholder="Confirm New Password"
                            minlength="1"
                            maxlength="32"
                            [ngModel]="confirmNewPassword"
                            (ngModelChange)="onChangeConfirmPassword($event)"
                            name="confirmnewpwd"
                            #confirmnewpwd="ngModel"
                            required
                        >
                        <mat-error *ngIf="confirmnewpwd.value?.length > 0 && confirmnewpwd.touched && confirmnewpwd.hasError('passwordValidator')">Please enter valid password</mat-error>
                        <mat-error *ngIf="confirmnewpwd.touched && !confirmnewpwd.hasError('passwordValidator') &&  confirmnewpwd.hasError('passwordDonotMatch')">
                            New Password and Confirm Password should match
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="change-password-action">
                    <button
                        mat-raised-button
                        color="primary"
                        class="mat-button-large"
                        type="submit"
                        [disabled]="!f.valid"
                    >
                        Change
                    </button>
                </div>
            </form>
        </div>
    </mat-card>
</div>
